export default __webpack_public_path__ + "static/garden_design31-89dd04054891d614693484cf933b3cfc.webp";